import {FETCH_LIVE_SCHEDULE} from '../actions/types.js';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_LIVE_SCHEDULE:
            return action.payload;
        default:
            return state;
    }
}